import React, { Component } from "react";
import AdmissionPrintRequest from "../Components/AdmissionPrint/AdmissionPrintRequest";
import ServiceGate from "../Components/ServiceGate";

class AdmissionPrintRequestPage extends Component {
  render() {
    return (
      <div className="jumbotron">
        <div className="container">
          <div className="reg-form">
            <div className="top-bar"></div>
            <div className="form-contents">
              <h3
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
              >
                <div style={{ marginLeft: 0, fontWeight: 700 }}>
                  Reprint Admission Receipt
                </div>
              </h3>
              <hr />

              <ServiceGate service="admission_print">
                <AdmissionPrintRequest {...this.props} />
              </ServiceGate>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdmissionPrintRequestPage;
